import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';

export class ErrorLoggingServiceStatic {
    LogClientError(error: string): Promise<AxiosResponse> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/logclienterror`
        return AxiosPostProcessor.postProcess(Axios.post(url, error, AxiosDefaultRequestConfig.merge({
          "headers" : {
            "Content-Type" : "text/plain"
          }
        })));
    }
}
const ErrorLoggingService = new ErrorLoggingServiceStatic();
export default ErrorLoggingService;
